// extracted by mini-css-extract-plugin
export default {"mainTr":"ArticleTableRow_mainTr__wQTea","hoverTr":"ArticleTableRow_hoverTr__UCYZa","collapseTr":"ArticleTableRow_collapseTr__tupOG"};